(() => {
  if (window.HydtecFormSubmissionLoaded) {
    return;
  }

  window.HydtecFormSubmissionLoaded = true;

  const quantitySelector =
    ".instant-price-quantity-input, [data-ip-quantity] .quantity__input";
  let activeQuantityInput = null;

  document.addEventListener("input", rememberQuantityInput, true);
  document.addEventListener("change", rememberQuantityInput, true);
  document.addEventListener("click", rememberOpenedQuantity, true);

  const forms = document.querySelectorAll("[data-hydtec-form-submission]");

  for (const form of forms) {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const submitButton = form.querySelector("[data-hydtec-form-submit]");
      const status = form.querySelector("[data-hydtec-form-status]");
      const formData = new FormData(form);
      const productId = getProductId(form);
      const productTitle = getProductTitle(form);
      const productSku = getProductSku(form);
      const rawQuantity = getQuantity(form, formData);
      const quantity = normalizeQuantity(rawQuantity);
      const endpoint =
        form.getAttribute("data-endpoint") ||
        "/apps/hydtec-3d-viewer/form-submission";

      console.info("[Hydtec Form] Submitting", {
        endpoint,
        productId,
        productTitle,
        productSku,
        quantity,
        rawQuantity,
        rawQuantityType: typeof rawQuantity,
        selectedVariantId: getSelectedVariantId(form),
      });

      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        const message = form.dataset.i18nInvalidQuantity;
        console.error("[Hydtec Form] Invalid quantity", {
          rawQuantity,
          rawQuantityType: typeof rawQuantity,
        });
        setStatus(status, message, true);
        return;
      }

      setStatus(status, "");
      setSubmitting(submitButton, true);

      try {
        const response = await fetch(
          endpoint,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              email: formData.get("email"),
              comment: formData.get("comment"),
              productId,
              productTitle,
              productSku,
              quantity,
              website: formData.get("website"),
            }),
          },
        );

        const data = await readResponse(response);

        console.info("[Hydtec Form] Response", {
          status: response.status,
          ok: response.ok,
          data,
        });

        if (!response.ok) {
          throw new Error(
            data?.error?.message || "Could not submit the form.",
          );
        }

        form.reset();
        setStatus(status, form.dataset.i18nSuccess, false);
      } catch (error) {
        console.error("[Hydtec Form] Submission failed", error);
        setStatus(status, form.dataset.i18nError, true);
      } finally {
        setSubmitting(submitButton, false);
      }
    });
  }

  function getProductId(form) {
    const renderedProductId = form.getAttribute("data-product-id");

    if (/^gid:\/\/shopify\/Product\/\d+$/.test(renderedProductId || "")) {
      return renderedProductId;
    }

    const productIdInput = document.querySelector(
      'form[action*="/cart/add"] [name="product-id"]',
    );
    const storefrontProductId =
      productIdInput?.value ||
      window.ShopifyAnalytics?.meta?.product?.id ||
      window.meta?.product?.id;

    if (storefrontProductId && /^\d+$/.test(String(storefrontProductId))) {
      return `gid://shopify/Product/${storefrontProductId}`;
    }

    console.error("[Hydtec Form] Could not determine the Shopify product ID", {
      renderedProductId,
      hasProductFormId: Boolean(productIdInput?.value),
      hasAnalyticsProductId: Boolean(
        window.ShopifyAnalytics?.meta?.product?.id,
      ),
      hasMetaProductId: Boolean(window.meta?.product?.id),
    });

    return renderedProductId || "";
  }

  function getProductSku(form) {
    return form.getAttribute("data-product-sku")?.trim() || "";
  }

  function getProductTitle(form) {
    const renderedTitle = form.getAttribute("data-product-title")?.trim();

    if (renderedTitle) {
      return renderedTitle;
    }

    return (
      window.ShopifyAnalytics?.meta?.product?.title ||
      window.ShopifyAnalytics?.meta?.product?.name ||
      window.meta?.product?.title ||
      document
        .querySelector(".product__title h1, .product__title, h1.product-title")
        ?.textContent?.trim() ||
      ""
    );
  }

  function getSelectedVariantId(form) {
    const productId = getProductId(form).split("/").pop();
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');

    for (const productForm of productForms) {
      const productIdInput = productForm.querySelector('[name="product-id"]');

      if (productIdInput && productIdInput.value !== productId) {
        continue;
      }

      const variantInput = productForm.querySelector('[name="id"]');

      if (variantInput?.value) {
        return variantInput.value;
      }
    }

    return new URL(window.location.href).searchParams.get("variant");
  }

  function getQuantity(form, formData) {
    const associatedQuantity = formData.get("quantity");

    if (associatedQuantity) {
      return associatedQuantity;
    }

    const modal = form.closest(".ip-modal-overlay[data-ip-id]");
    const instantPriceId = modal?.getAttribute("data-ip-id");
    let quantityInput = null;

    if (instantPriceId) {
      const instantPriceWraps = document.querySelectorAll(".ip-wrap[data-ip-id]");

      for (const wrap of instantPriceWraps) {
        if (wrap.getAttribute("data-ip-id") === instantPriceId) {
          quantityInput = wrap.querySelector(
            quantitySelector,
          );
          break;
        }
      }
    }

    if (!quantityInput && activeQuantityInput?.isConnected) {
      quantityInput = activeQuantityInput;
    }

    if (!quantityInput) {
      const quantityInputs = document.querySelectorAll(quantitySelector);
      quantityInput = Array.from(quantityInputs).find(isVisible) || quantityInputs[0];
    }

    return quantityInput?.value || null;
  }

  function normalizeQuantity(value) {
    if (typeof value === "string" && value.trim()) {
      return Number(value);
    }

    return value;
  }

  function rememberQuantityInput(event) {
    if (event.target.matches?.(quantitySelector)) {
      activeQuantityInput = event.target;
    }
  }

  function rememberOpenedQuantity(event) {
    const opener = event.target.closest?.("[data-ip-open]");
    const wrap = opener?.closest(".ip-wrap");
    const quantityInput = wrap?.querySelector(quantitySelector);

    if (quantityInput) {
      activeQuantityInput = quantityInput;
    }
  }

  function isVisible(element) {
    return element.getClientRects().length > 0;
  }

  function setSubmitting(button, isSubmitting) {
    if (!button) {
      return;
    }

    button.dataset.originalText ||= button.textContent;
    button.disabled = isSubmitting;
    button.textContent = isSubmitting
      ? button.form.dataset.i18nSubmitting
      : button.dataset.originalText;
  }

  function setStatus(element, message, isError = false) {
    if (!element) {
      return;
    }

    element.textContent = message;
    element.classList.toggle("hydtec-form-submission__status--error", isError);
  }

  async function readResponse(response) {
    const text = await response.text();

    if (!text) {
      return null;
    }

    try {
      return JSON.parse(text);
    } catch {
      if (!response.ok) {
        throw new Error(
          `Could not submit the form. Server returned HTTP ${response.status}.`,
        );
      }

      throw new Error("Could not submit the form. Server returned invalid JSON.");
    }
  }
})();
